import React from 'react';
import Button from 'gatsby-theme-core/src/components/button/index';
import InputField from 'gatsby-theme-core/src/components/form-elements/input';
import DateField from 'gatsby-theme-core/src/components/form-elements/date';
import FileField from 'gatsby-theme-core/src/components/form-elements/file';
import TitleField from 'gatsby-theme-core/src/components/form-elements/title';
import NoteField from 'gatsby-theme-core/src/components/form-elements/note';
import SelectField from 'gatsby-theme-core/src/components/form-elements/select';
import TextareaField from 'gatsby-theme-core/src/components/form-elements/textarea';
import InlineRadioField from 'gatsby-theme-core/src/components/form-elements/inline-radio';
import MultiCheckboxField from 'gatsby-theme-core/src/components/form-elements/checkbox/multi';
import MultiRadioField from 'gatsby-theme-core/src/components/form-elements/radio/multi';
import LicensePlateField from './license-plate-input';

const FormField = ({
  inLocationState,
  hideWhenInLocationState,
  element,
  ...props
}) => {
  if (inLocationState && hideWhenInLocationState) {
    return null;
  }
  switch (element) {
    case 'hidden':
      return null;
    case 'title':
      return <TitleField {...props} />;
    case 'note':
      return <NoteField {...props} />;
    case 'select':
      return <SelectField {...props} />;
    case 'file':
      return <FileField {...props} />;
    case 'date':
      return <DateField useDatePicker={false} {...props} />;
    case 'input':
      return <InputField {...props} />;
    case 'textarea':
      return <TextareaField {...props} />;
    case 'radio':
      return <InlineRadioField {...props} />;
    case 'checkboxes':
      return <MultiCheckboxField {...props} />;
    case 'radios':
      return <MultiRadioField {...props} />;
    case 'button':
      return <Button {...props} dependsOn={null} css={props.css} />;
    case 'licensePlate':
      return <LicensePlateField {...props} />;
    default:
      return <InputField {...props} />;
  }
};

export default FormField;
